const MEDIA_FILE_EXTENSION_REGEX = /\.(?:jpg|jpeg|png|webp|gif|svg|mp4|mov|m4v|webm|avi|mkv|flv|mp3|aac|wav|ogg|m4a)(?:[?#]|$)/i;

export const hasMediaFileExtension = (url: string) =>
  MEDIA_FILE_EXTENSION_REGEX.test(url.trim());

export const isMediaContentType = (contentType: string | null) =>
  Boolean(
    contentType &&
      (contentType.includes("image") ||
        contentType.includes("video") ||
        contentType.includes("audio"))
  );
